import { GalleryImage, GalleryImageResponse } from '../models/GalleryImage';

export const projectGalleryMapper = (
    galleryImage: GalleryImageResponse
): GalleryImage => {
    return {
        url: galleryImage?.url ?? '',
    };
};
